import { URLHelpers } from 'src/helpers/URLHelpers';

import { AppName, UserReferrer } from 'models';
import { MarketingHelpers } from 'helpers/MarketingHelpers';

const REPLUS_ROUTES = ['/resourcepro', '/replus', '/scan', '/qr', '/showtime', '/events'];

const SHARED_ROUTES = [
    '/products',
    '/profiles',
    '/designs',
    '/case-studies',
    '/map',
    '/bookmarks',
    '/inbox',
    '/messages',
    '/account',
    '/search',
    '/login',
];

// Visitors who land on the catalog without a known default app most likely come from RE+.
const REPLUS_LEANING_ROUTES = ['/products', '/profiles'];

type ResolveProps = {
    pathname: string;
    workspace: boolean;
    lastActiveApp?: AppName;
    defaultApp?: AppName;
    loginRedirect?: string;
};

const AppHelpers = {
    storageKey: {
        lastActiveApp: 'lastActiveApp',
    },

    isShared: (pathname: string) => URLHelpers.pathMatches(pathname, SHARED_ROUTES),

    isValidAppName: (value: unknown): value is AppName => Object.values(AppName).includes(value as AppName),

    getRouteOwner: (pathname: string): AppName | undefined => {
        // Shared routes have no owner: they follow the visitor
        if (AppHelpers.isShared(pathname)) {
            return undefined;
        }

        return URLHelpers.pathMatches(pathname, REPLUS_ROUTES) ? AppName.REPLUS : AppName.DCIDE;
    },

    getAppForReferrer: (referrer?: UserReferrer) => (referrer === UserReferrer.REPLUS ? AppName.REPLUS : AppName.DCIDE),

    getHomeUrl: (app: AppName, loggedIn: boolean) => {
        if (app === AppName.REPLUS) {
            return loggedIn
                ? MarketingHelpers.urls.resourcepro.dashboard()
                : MarketingHelpers.urls.resourcepro.overview();
        }

        return '/';
    },

    resolve: ({ pathname, workspace, lastActiveApp, defaultApp, loginRedirect }: ResolveProps): AppName => {
        if (workspace) {
            return AppName.DCIDE;
        }

        const owner = AppHelpers.getRouteOwner(pathname);

        if (owner) {
            return owner;
        }

        if (loginRedirect) {
            return AppHelpers.resolve({ pathname: loginRedirect, workspace, lastActiveApp, defaultApp });
        }

        if (lastActiveApp) {
            return lastActiveApp;
        }

        if (defaultApp) {
            return defaultApp;
        }

        return URLHelpers.pathMatches(pathname, REPLUS_LEANING_ROUTES) ? AppName.REPLUS : AppName.DCIDE;
    },
};

export { AppHelpers };
